import {useState} from "react";
import axios from "axios";
import config from "../../../config";
import './PreAssessmentQuestionsMobile.css';
import React from 'react'
import {useTranslation} from "react-i18next";

interface PreAssessmentQuestionsMobileProps {
    fields: any
    setNewCurrentStep(step: number): void
    openModal(content: string): void
}
function PreAssessmentQuestionsMobile(props: PreAssessmentQuestionsMobileProps) {
    const { t, i18n } = useTranslation();

    const [currentStep, setCurrentStep] = useState<number>(1);
    const [q1, setQ1] = useState('');
    const [q2, setQ2] = useState('');
    const [requiredFiledError, setRequiredFiledError] = useState(false);
    const [loaderIsActive, setLoaderIsActive] = useState(false);


    const handleNextStep = () => {
        setRequiredFiledError(false);

        if (currentStep === 1) {
            if (!q1) {
                setRequiredFiledError(true);
            } else {
                q1 === 'No' ?  setCurrentStep(3) : setCurrentStep(2);
            }
        }

        if (currentStep === 2) {
            if (!q2) {
                setRequiredFiledError(true);
            } else if (q2 === 'Pregnant') {
                props.openModal(t("Pregnancy Error"));
                return;
            }
            else {
                setCurrentStep(3);
            }
        }

        if (currentStep === 3) {
            submitForm();
        }
    }

    const convertObjToArr = (obj: any): { value: string, label: any }[] => {
        return Object.entries(obj).map(([key, value]) => ({
            value: key,
            label: value || ''
        }))
    }
    const submitForm = async () => {
        try {
            setLoaderIsActive(true);

            await axios.post(
                config.API_URL_FOR_LOCAL_DEVELOPMENT + '/api/v1/pre-assessment/questions/store',
                {
                    q1,
                    q2,
                    incompleteAssessment: q1 === 'No',
                    language: config.LANGUAGE || 'en',
                    landingUserId: window.localStorage.getItem('landingUserId'),
                }
            );

            props.setNewCurrentStep(2)
        } catch (error) {
            console.error('Error while sending data:', error);
        } finally {
            setLoaderIsActive(false);
        }
    }

    const handleBack = () => {
        if (currentStep === 1) {
            props.setNewCurrentStep(0)
        } else if (currentStep === 3) {
            q1 === 'No' ? setCurrentStep(1) : setCurrentStep(2);
        } else {
            setCurrentStep((prevState) => prevState - 1)
        }
    }

    return (
        <div className='PreAssessmentQuestionsMobile d-flex flex-column justify-content-between position-relative'>

            <div>
                {
                    currentStep === 1 &&
                    <div className='step-1'>
                        <div className='box-1'>
                            <div className='label-1 mb-2 text-center'>
                                {props.fields['q1'].label}
                            </div>

                            <label className='d-flex mb-15'>
                                <input
                                    className='d-none'
                                    type="radio"
                                    name="q1"
                                    checked={q1 === 'Yes'}
                                    onChange={() => setQ1('Yes')}
                                />

                                <div
                                    className={q1 === 'Yes' ? 'checkbox-1 checkbox-1--checked mr-15' : 'checkbox-1 mr-15'}
                                    role='button'
                                ></div>

                                <span role='button'>{props.fields['q1']?.options['Yes']}</span>
                            </label>

                            <label className='d-flex mb-15'>
                                <input
                                    className='d-none'
                                    type="radio"
                                    name="q1"
                                    checked={q1 === 'No'}
                                    onChange={() => setQ1('No')}
                                />

                                <div
                                    className={q1 === 'No' ? 'checkbox-1 checkbox-1--checked mr-15' : 'checkbox-1 mr-15'}
                                    role='button'
                                ></div>

                                <span role='button'>{props.fields['q1'].options['No']}</span>
                            </label>
                        </div>
                    </div>
                }

                {
                    currentStep === 2 &&
                    <div className='step-2'>
                        <div className='box-1'>
                            <div className='label-1 mb-2'>
                                {props.fields['q2'].label}
                            </div>

                            <div className='row'>
                                <div className='col-12 col-md-6'>
                                    {
                                        props.fields['q2'] && convertObjToArr(props.fields['q2'].options)
                                            .splice(0, (convertObjToArr(props.fields['q2'].options).length - 1) / 2)
                                            .map((option, index) => (
                                                <div key={index}>
                                                    <label className='d-flex mb-15'>
                                                        <input
                                                            className='d-none'
                                                            type="radio"
                                                            name="q2"
                                                            checked={q2 === option.value}
                                                            onChange={() => setQ2(option.value)}
                                                        />

                                                        <div
                                                            className={q2 === option.value ? 'checkbox-1 checkbox-1--checked mr-15' : 'checkbox-1 mr-15'}
                                                            role='button'
                                                        ></div>

                                                        <span role='button'>{option.label}</span>
                                                    </label>
                                                </div>
                                            ))
                                    }
                                </div>

                                <div className='col-12 col-md-6'>
                                    {
                                        convertObjToArr(props.fields['q2'].options)
                                            .splice( (convertObjToArr(props.fields['q2'].options).length - 1) / 2, convertObjToArr(props.fields['q2'].options).length - 1)
                                            .map((option, index) => (
                                                <div key={index}>
                                                    <label className='d-flex mb-2'>
                                                        <input
                                                            className='d-none'
                                                            type="radio"
                                                            name="q2"
                                                            checked={q2 === option.value}
                                                            onChange={() => setQ2(option.value)}
                                                        />

                                                        <div
                                                            className={q2 === option.value ? 'checkbox-1 checkbox-1--checked mr-15' : 'checkbox-1 mr-15'}
                                                            role='button'
                                                        ></div>

                                                        <span role='button'>{option.label}</span>
                                                    </label>
                                                </div>
                                            ))
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                }

                {
                    currentStep === 3 &&
                    <div className='step-3'>
                        <div className='box-1 mt-2'>
                            <p>{t('PreAssessment Step 3 Content')}</p>
                        </div>
                    </div>
                }
            </div>

            <footer className='mt-2'>

                {
                    requiredFiledError &&
                    <div className='form-error mb-15 text-center'>{t('Complete the required field')}</div>
                }

                <div className='d-flex justify-content-center align-items-center'>
                    <button
                        className='button-1 mr-6'
                        onClick={() => handleBack()}
                    >
                        {t("Back Button")}
                    </button>

                    <button
                        className='button-1'
                        onClick={() => handleNextStep()}
                    >
                        {t("Continue Button")}
                    </button>
                </div>
            </footer>

            {loaderIsActive && <div className='submitting-overlay'></div>}
        </div>
    )
}

export default PreAssessmentQuestionsMobile;